export const BREAKPOINT = 596;
export const MAX_WIDTH_MAIN = 830;
